import React, { useRef } from 'react';

export default function ModalOverlay({ onClose, children }) {
  const mouseDownOnOverlay = useRef(false);

  const handleMouseDown = (e) => {
    mouseDownOnOverlay.current = e.target === e.currentTarget;
  };

  const handleClick = (e) => {
    if (mouseDownOnOverlay.current && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={handleMouseDown} onClick={handleClick}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
